// The mobile bottom bar owns the guest login popup (see MobileFooterBar). Other mobile surfaces,
// such as the product filter drawer, ask it to open that same popup through this event, so a
// login started from them behaves exactly like the bar's own Login button.
export const OPEN_MOBILE_LOGIN_EVENT = 'mlgs:open-mobile-login';

export interface OpenMobileLoginDetail {
  // a customer who logs in stays on the current page instead of being sent to the home page
  stayOnPage?: boolean;
}

export const openMobileLogin = (detail: OpenMobileLoginDetail = {}) => {
  window.dispatchEvent(new CustomEvent<OpenMobileLoginDetail>(OPEN_MOBILE_LOGIN_EVENT, { detail }));
};
